// Ходы ботов в хотсите: по таймеру после отрисовки (мгновенно все разом или по шагу с анимациями), подготовка.
import type { Game as GameState, PlayerId } from '../types.ts';
import { player, setupDone } from '../engine/state.ts';
import { applyAction } from '../engine/game.ts';
import * as Bot from '../engine/bot.ts';
import { needPid } from './board.ts';
import { st, ui, save } from './store.ts';
import { render } from './render.ts';
import { resolvePendingTarget } from './flow.ts';

/** Ходы ботов после текущей отрисовки: мгновенный режим — все разом, старый — по шагу с паузой на анимации */
export function scheduleBots(): void {
  if (st.net || ui.botTimer) return;
  const delay = ui.instantBots ? 0 : st.G?.prompt ? 900 : 700;
  ui.botTimer = setTimeout(() => {
    ui.botTimer = null;
    if (ui.instantBots) runBots();
    else botStep();
    render();
  }, delay);
}
/** Один шаг бота (старый анимационный режим) */
function botStep(): void {
  const g = st.G;
  if (st.net || !g || g.phase !== 'play') return;
  const pid = needPid(g);
  if (!player(g, pid).bot) return;
  const d = Bot.decide(g, pid);
  if (!d) return;
  applyAction(g, pid, d);
  resolvePendingTarget();
  save();
}
/** Все шаги ботов подряд (без отрисовки); true — хоть один сделан */
function runBots(): boolean {
  const g = st.G;
  if (st.net || !g) return false;
  let steps = 0;
  while (g.phase === 'play' && steps < 2000) {
    const pid = needPid(g);
    if (!player(g, pid).bot) break;
    const d = Bot.decide(g, pid);
    if (!d) break;
    applyAction(g, pid, d);
    steps++;
  }
  if (!steps) return false;
  resolvePendingTarget();
  save();
  return true;
}
/** Для автотестов: ходы ботов без ожидания (если сейчас ход/решение бота) */
export function botNow(): boolean {
  if (st.net || !st.G) return false;
  if (ui.botTimer) clearTimeout(ui.botTimer);
  ui.botTimer = null;
  const did = runBots();
  if (did) render();
  return did;
}

/** Ход бота в подготовке (выбор жетона/фамильяра или третьего фамильяра) */
export function botSetupStep(g: GameState, pid: PlayerId): void {
  const p = player(g, pid);
  // с v11 первая фаза — два действия: жетон, затем фамильяр
  do {
    const d = Bot.decide(g, pid);
    if (!d || (d.name !== 'setupChoose' && d.name !== 'setupFamiliar' && d.name !== 'setupThird')) throw new Error(`Бот ${p.name} не сделал выбор в подготовке`);
    const r = applyAction(g, pid, d);
    if (!r.ok) throw new Error(`Бот ${p.name}: ${r.error}`);
  } while (g.phase === 'setup' && !setupDone(player(g, pid)));
}

/** Следующий после from игрок, которому предстоит выбор в подготовке (сначала жетоны, потом третьи фамильяры); null — всё выбрано */
export function nextSetupPid(g: GameState, from: PlayerId): PlayerId | null {
  if (g.phase !== 'setup') return null;
  for (let i = from + 1; i < g.players.length; i++) if (!setupDone(player(g, i))) return i;
  return g.setup?.third?.[0] ?? null;
}
